import React from "react";
import { motion } from "framer-motion";
import ButtonPrev from "../../ui/ButtonPrev";
import ButtonNext from "../../ui/ButtonNext";

const Carousel = ({ images, className }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Current Image */}
      <motion.img
        key={images[currentIndex].src}
        src={images[currentIndex].src}
        srcSet={images[currentIndex].srcSet}
        alt={images[currentIndex].alt}
        className={`w-full h-96 2xl:h-96 xl:h-96 lg:h-96 md:h-80 sm:h-64 xxs:h-48 rounded transition-transform ${images[currentIndex].className}`}
        initial={{ opacity: 0, scale: 1.3 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      />

      {/* Navigation Buttons */}
      <ButtonPrev
        onClick={handlePrev}
        aria-label="Previous Slide"
        className="absolute top-[45%] 2xl:top-[45%] xl:top-[45%] lg:top-[45%] md:top-[45%] sm:top-1/3 xs:top-1/3 xxs:top-1/3 xxs:left-1 left-2 transform -translate-y-1/2 w-10 h-10 bg-[#14532D] text-4xl text-white rounded-full shadow-2xl hover:bg-[#0c4020] pr-[3px]"
      />
      <ButtonNext
        onClick={handleNext}
        aria-label="Next Slide"
        className="absolute top-[45%] 2xl:top-[45%] xl:top-[45%] lg:top-[45%] md:top-[45%] sm:top-1/3 xs:top-1/3 xxs:top-1/3 xxs:right-1 right-2 transform -translate-y-1/2 w-10 h-10 bg-[#14532D] text-4xl text-white rounded-full shadow-2xl hover:bg-[#0c4020] pr-[3px]"
      />
      <div className="flex space-x-2 mt-10 justify-center">
        {images.map((_, index) => (
          <button
            key={index}
            className={`w-4 h-4 rounded-full ${
              index === currentIndex ? "bg-green-900" : "bg-green-600"
            } shadow-md hover:shadow-lg transition-shadow duration-300`}
            onClick={() => setCurrentIndex(index)}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
